// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainNavigation_logo__aNRpz","nav":"MainNavigation_nav__kq0zJ","navContainer":"MainNavigation_navContainer__8yppe"};